import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Fn_FillListData } from "../../../store/Functions";
import { API_WEB_URLS } from "../../../constants/constAPI";

const MONTH_NAMES = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December"
];

const currentYear = new Date().getFullYear();
const YEAR_LIST = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

// Dispatch a storage event so other tabs/components can react to localStorage changes
const notifyStorage = () => window.dispatchEvent(new Event("storage"));

const Home = () => {
  const dispatch = useDispatch();
  const [firmList, setFirmList] = useState([]);
  const [selectedFirm, setSelectedFirm] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(() => localStorage.getItem("selectedPayrollMonth") || "");
  const [selectedYear, setSelectedYear] = useState(() => localStorage.getItem("selectedPayrollYear") || "");

  // Load firm list on mount
  useEffect(() => {
    const apiURL =
      API_WEB_URLS.MASTER + "/0/token/" + API_WEB_URLS.FirmMaster + "/Id/0";
    Fn_FillListData(dispatch, setFirmList, "gridData", apiURL);

    // Restore firm from localStorage
    const saved = localStorage.getItem("selectedFirm");
    if (saved) {
      try { setSelectedFirm(JSON.parse(saved)); } catch {}
    }
  }, [dispatch]);

  const handleFirmChange = (e) => {
    const id = e.target.value;
    if (!id) {
      setSelectedFirm(null);
      localStorage.removeItem("selectedFirm");
      notifyStorage();
      return;
    }
    const firm = firmList.find((f) => String(f.Id) === String(id));
    if (firm) {
      setSelectedFirm(firm);
      localStorage.setItem("selectedFirm", JSON.stringify(firm));
      notifyStorage();
    }
  };

  const handleMonthChange = (e) => {
    const val = e.target.value;
    setSelectedMonth(val);
    if (val) {
      localStorage.setItem("selectedPayrollMonth", val);
    } else {
      localStorage.removeItem("selectedPayrollMonth");
    }
    notifyStorage();
  };

  const handleYearChange = (e) => {
    const val = e.target.value;
    setSelectedYear(val);
    if (val) {
      localStorage.setItem("selectedPayrollYear", val);
    } else {
      localStorage.removeItem("selectedPayrollYear");
    }
    notifyStorage();
  };

  const isComplete = !!selectedFirm && !!selectedMonth && !!selectedYear;

  return (
    <>
      <div className="row justify-content-center" style={{ marginTop: "60px" }}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Payroll Session Setup</h5>
            </div>
            <div className="card-body">

              {/* Firm */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Firm</label>
                <select
                  className="form-select"
                  value={selectedFirm ? selectedFirm.Id : ""}
                  onChange={handleFirmChange}
                >
                  <option value="">-- Select Firm --</option>
                  {firmList.map((firm) => (
                    <option key={firm.Id} value={firm.Id}>{firm.Name}</option>
                  ))}
                </select>
              </div>

              {/* Month & Year side-by-side */}
              <div className="row mb-3">
                <div className="col-6">
                  <label className="form-label fw-semibold">Month</label>
                  <select
                    className="form-select"
                    value={selectedMonth}
                    onChange={handleMonthChange}
                  >
                    <option value="">-- Select Month --</option>
                    {MONTH_NAMES.map((m) => (
                      <option key={m} value={m}>{m}</option>
                    ))}
                  </select>
                </div>
                <div className="col-6">
                  <label className="form-label fw-semibold">Year</label>
                  <select
                    className="form-select"
                    value={selectedYear}
                    onChange={handleYearChange}
                  >
                    <option value="">-- Select Year --</option>
                    {YEAR_LIST.map((y) => (
                      <option key={y} value={y}>{y}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Summary badge */}
              {isComplete ? (
                <div
                  style={{
                    background: "#e8f5e9",
                    border: "1px solid #a5d6a7",
                    padding: "8px 14px",
                    fontSize: "13px",
                    color: "#2e7d32",
                    borderRadius: 4,
                  }}
                >
                  ✔ <strong>{selectedFirm.Name}</strong> &nbsp;|&nbsp;
                  <strong>{selectedMonth} {selectedYear}</strong> &nbsp;— Payroll session active
                </div>
              ) : (
                <div
                  style={{
                    background: "#fff3e0",
                    border: "1px solid #ffcc80",
                    padding: "8px 14px",
                    fontSize: "12px",
                    color: "#e65100",
                    borderRadius: 4,
                  }}
                >
                  Please select Firm, Month and Year to enable Payroll.
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;